import { useLocation, useHistory } from 'react-router-dom';
import { useEffect } from 'react';

const useRedirect = (searchValue, replaceValue) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const newRoute = location.pathname.replace(searchValue, replaceValue);
    history.replace(newRoute + window.location.search);
  }, [history, location.pathname, replaceValue, searchValue]);
};

export default useRedirect;
